import _ from 'lodash'

export default class Helper {
  static cleanHtmlCssWhiteSpaceFromString (html) {
    let output

    const stringStripper = /(\n|\r| class=(")?Mso[a-zA-Z]+(")?)/g
    output = html.replace(stringStripper, '')

    const commentSripper = new RegExp('<!--(.*?)-->', 'g')
    output = output.replace(commentSripper, '')

    const tagStripper = new RegExp('<(/)*(meta|link|span|\\?xml:|st1:|o:|font)(.*?)>', 'gi')
    output = output.replace(tagStripper, '')

    const badTags = ['style', 'script', 'applet', 'embed', 'noframes', 'noscript']
    for (let i = 0; i < badTags.length; i++) {
      const tagStripper = new RegExp('<' + badTags[i] + '.*?' + badTags[i] + '(.*?)>', 'gi')
      output = output.replace(tagStripper, '')
    }

    const badAttributes = ['style', 'start']
    for (let i = 0; i < badAttributes.length; i++) {
      const attributeStripper = new RegExp(' ' + badAttributes[i] + '="(.*?)"', 'gi')
      output = output.replace(attributeStripper, '')
    }

    output = `<p>${output}</p>`
    output = $(output).text().replace(/\s+/g, '')  // eslint-disable-line

    return output
  }

  static getBase64 (file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => resolve(reader.result)
      reader.onerror = error => reject(error)
    })
  }

  static mergeObject (obj1, obj2) {
    Object.keys(obj1).forEach((p) => {
      if (Object.prototype.hasOwnProperty.call(obj2, p)) {
        try {
          if (obj2[p] && obj2[p].constructor === Object) {
            obj1[p] = this.mergeObject(obj1[p], obj2[p])
          } else if (obj2[p] !== obj1[p] && obj2[p] !== null) {
            obj1[p] = _.cloneDeep(obj2[p])
          }
        } catch (e) {
          obj1[p] = _.cloneDeep(obj2[p])
        }
      }
    })
    return obj1
  }
}



// WEBPACK FOOTER //
// ./src/utils/helper.js